import CounterStyle from '../CounterStyle';
import makeAlphanumMaxlenComputer from '../makeAlphanumMaxlenComputer';
// Default implementation is faster than invoking CounterStyle.numeric
var decimal = CounterStyle.raw(function (index) {
  return index.toString();
}).withMaxLengthComputer(makeAlphanumMaxlenComputer(10, false)).withNegative('-');
export default decimal;